import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import * as fromRepository from './+state/repository.reducer';
import {RepositoryEffects} from './+state/repository.effects';
import {HttpClientModule} from '@angular/common/http';
import {RepositoryDataService} from './+state/repository-data.service';
import {NGXLogger} from 'ngx-logger';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forFeature(
      fromRepository.REPOSITORY_FEATURE_KEY,
      fromRepository.reducer
    ),
    EffectsModule.forFeature([RepositoryEffects]),
  ],
  providers: [RepositoryDataService],
  declarations: [],
  exports: []
})
export class RepositoryStoreModule {

  constructor(private logger: NGXLogger) {
    logger.trace('*---------------------------------------------------------------------*');
    logger.trace('*', this.constructor.name, 'Loaded');
    logger.trace('*---------------------------------------------------------------------*');
  }

}
